import React from "react";
import RSelect, { Props, components, OptionProps } from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";

export const Select: React.FC<Props & { icon?: boolean }> = (props) => {
  const selectStyles = {
    control: (base: any) => ({
      ...base,
      height: 38,
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      padding: 4,
    }),
    clearIndicator: (base: any) => ({
      ...base,
      padding: 4,
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: "0px 4px",
    }),
    input: (base: any) => ({
      ...base,
      margin: 0,
      padding: 0,
      height: 38,
    }),
  };

  const { Option } = components;
  const IconOption = (props: OptionProps<any>) => (
    <Option {...props}>
      <img src={props.data.icon} style={{ width: 30 }} alt={props.data.label} />
    </Option>
  );
  return (
    <RSelect
      styles={selectStyles}
      //@ts-ignore
      getOptionLabel={(option: any) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {props.icon ? (
            <img src={option.label} style={{ width: 30 }} alt={option.label} />
          ) : (
            <span style={{ marginLeft: 5 }}>{option.label}</span>
          )}
        </div>
      )}
      {...(props.icon && { components: { Option: IconOption } })}
      {...props}
    />
  );
};
